import { render, staticRenderFns } from "./voicemail.vue?vue&type=template&id=24ddce67&"
import script from "./voicemail.vue?vue&type=script&lang=js&"
export * from "./voicemail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports